export namespace ACEditMetricListConst {
  export const ToolTipConst = {
    questionEn: `Group Metrics: Indicator Name.<br/>
            Metric Name: Sub indicator name to config.<br/>
            Value: The specific indicator being evaluated.<br/>
            Description: Sub indicator description.<br/>
            Operator: The comparison symbol (e.g., >) used to determine how the value is compared to the operator value.<br/>
            Operator Value: The threshold value used in conjunction with the operator for the sub indicator.<br/>
            RAG Score: Red Amber Green score for each sub indicator.<br/>
            Multiplier: a factor by which the Rag score is multiplied to adjust sub indicator impact or weight in the overall calculation.`,
    questionVn: `Nhóm số liệu: Tên chỉ số.<br/>
            Tên số liệu: Tên chỉ số phụ để cấu hình.<br/>
            Giá trị: Chỉ số cụ thể đang được đánh giá.<br/>
            Mô tả: Mô tả chỉ số phụ.<br/>
            Toán tử: Ký hiệu so sánh (ví dụ: >) được sử dụng để xác định cách giá trị được so sánh với giá trị toán tử.<br/>
            Giá trị toán tử: Giá trị ngưỡng được sử dụng cùng với toán tử cho chỉ số phụ.<br/>
            Điểm RAG: Điểm Red Amber Green cho mỗi chỉ số phụ.<br/>
            Hệ số nhân: là hệ số mà điểm Rag được nhân để điều chỉnh tác động hoặc trọng số của chỉ số phụ trong tính toán tổng thể.`
  }

  export const OperatorConst = [
    {
      label: '=',
      value: '='
    },
    {
      label: '>',
      value: '>'
    },
    {
      label: '<',
      value: '<'
    },
    {
      label: '>=',
      value: '>='
    },
    {
      label: '<=',
      value: '<='
    }
  ]
}